import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { nanoid } from 'nanoid';
import { useStyles } from '../style';
import NavLink from './NavLink';
import NavList from './NavList';

/**
 * @name TopNavLinks
 * @description Top Navigation links
 * @param {object} root0  - destructured object
 * @param {object} root0.links  - List of navigation items from strapi
 * @param {boolean} root0.leftLink  -Flag to determine left or right navigation
 * @returns {JSX.Element} JSX.Element
 */
const TopNavLinks = ({ links, leftLink = false }) => {
  const theme = useTheme();
  const style = useStyles(theme);

  return (
    <Stack direction='row' alignItems='center'>
      {leftLink
        ? links?.SecondaryNavLeft?.Link?.map((data, i) => (
            <NavLink key={nanoid(8)} href={data?.link} aria-label={data?.ariaLabel}>
              <Typography
                variant='body2'
                component='p'
                sx={leftLink && i === 0 ? style.topNav : style.topNavTitle}
              >
                {data.title}
              </Typography>
            </NavLink>
        ))
        : links?.SecondaryNavRight?.map(data =>
          data?.Link?.map((nav, index) => (
              <NavLink key={nanoid(8)} href={nav?.link} aria-label={nav?.ariaLabel}>
                <NavList index={index} data={data} nav={nav} leftLink={leftLink} />
              </NavLink>
          )))}
    </Stack>
  );
};

TopNavLinks.displayName = 'TopNavLinks';
export default TopNavLinks;
